
<v-tooltip
  v-model="show"
  :right="resolvedDirection === 'right'"
  :left="resolvedDirection === 'left'"
  :top="resolvedDirection === 'top'"
  :bottom="resolvedDirection === 'bottom'"
  :attach="attach"
  :nudge-bottom="resolvedDirection === 'bottom' ? nudge : undefined"
  :nudge-top="resolvedDirection === 'top' ? nudge : undefined"
  :nudge-left="resolvedDirection === 'left' ? nudge : undefined"
  :nudge-right="resolvedDirection === 'right' ? nudge : undefined"
  :open-on-hover="hoverMode"
  content-class="tooltip"
>
  <template v-slot:activator="{ on, attrs }">
    <span
      v-bind="attrs"
      v-on="combinedListeners(on)"
      @click.stop="handleClick"
      ref="activator"
    >
      <slot name="trigger" />
    </span>
  </template>
  <div
    ref="tooltipContent"
    @mouseenter="handleTooltipEnter"
    @mouseleave="handleTooltipLeave"
  >
    <slot name="text" />
  </div>
</v-tooltip>
